<template>
    <div class="course-container">
        <!--详情-->
        <div class="lesson-container" v-show="this.showMode==='view'">
            <div class="top-title">协同备课详情</div>
            <div class="info-column-container-top">
                <div class="flex-item column-title">基本信息</div>
                <div class="flex-item column-status" v-if="lessonInfo.status===1">初始</div>
                <div class="flex-item column-status" v-if="lessonInfo.status===2">一轮研讨</div>
                <div class="flex-item column-status" v-if="lessonInfo.status===3&&lessonInfo.discussMode===2">初案修正</div>
                <div class="flex-item column-status" v-if="lessonInfo.status===3&&lessonInfo.discussMode===1">共案上传</div>
                <div class="flex-item column-status" v-if="lessonInfo.status===4&&lessonInfo.discussMode===2">二轮研讨</div>
                <div class="flex-item column-status" v-if="lessonInfo.status===5&&lessonInfo.discussMode===2">共案修正</div>
                <div class="flex-item column-status" v-if="lessonInfo.status===8">教学反思</div>
                <div class="flex-item column-status-fb" v-if="lessonInfo.status===9">备课完成</div>
                <div class="flex-item column-status ml10" v-if="lessonInfo.status===9&&lessonInfo.releaseStatus===0&& lessonInfo.role === 0">未发布</div>
                <div class="flex-item column-status ml10" v-if="lessonInfo.status===9&&lessonInfo.releaseStatus===1&& lessonInfo.role === 0">发布审核中</div>
                <div class="flex-item column-status-fb ml10" v-if="lessonInfo.status===9&&lessonInfo.releaseStatus===2&& lessonInfo.role === 0">已发布</div>
                <div class="flex-item column-status-fb ml10" v-if="lessonInfo.status===9&&lessonInfo.releaseStatus===3&& lessonInfo.role === 0">发布拒绝</div>
                <div class="flex-item column-btn">
                    <div class="btn"
                         v-if="(lessonInfo.status===1||lessonInfo.status===2)
                                && lessonInfo.role === 0"
                         @click="handleUploadCaFile">
                        上传初案
                    </div>
                    <div class="btn"
                         v-if="lessonInfo.status===3 && lessonInfo.role === 0&&lessonInfo.discussMode===2"
                         @click="handleUploadXzaFile">
                        传修正案
                    </div>
                    <!-- 进入一轮研讨-->
                    <div class="btn" v-if="lessonInfo.status===1&& lessonInfo.role === 0"
                         @click="handleSubmit">
                        开始备课
                    </div>
                    <!-- 进入二轮研讨-->
                    <div class="btn" v-if="lessonInfo.status===3&& lessonInfo.role === 0&&lessonInfo.discussMode===2"
                         @click="beginSecondDiscuss">
                        开始协同
                    </div>
                    <div class="btn" v-if="(lessonInfo.status===2||lessonInfo.status===4)
                                && lessonInfo.role !== 2"
                         @click="handleDiscuss">
                        参与研讨
                    </div>
                    <div class="btn" v-if="((lessonInfo.status===3&&lessonInfo.discussMode===1)||(lessonInfo.status===5&&lessonInfo.discussMode===2))&& lessonInfo.role === 0"
                         @click="handleUploadGaFile">
                        上传共案
                    </div>
                    <div class="btn" v-if="((lessonInfo.status===3&&lessonInfo.discussMode===1)||(lessonInfo.status===5&&lessonInfo.discussMode===2))&& lessonInfo.role === 0"
                         @click="handleReflection">
                        教学反思
                    </div>
                    <div class="btn" v-if="lessonInfo.status===8&& lessonInfo.role !== 2"
                         @click="handleUploadReflection">
                        上传反思
                    </div>
                    <div class="btn" v-if="(lessonInfo.status===8)&& lessonInfo.role === 0"
                         @click="handleEndLesson">
                        结束备课
                    </div>
                    <div class="btn" v-if="(lessonInfo.status===2||lessonInfo.status===4)
                            && lessonInfo.role === 0"
                         @click="handleMeeting">
                        发起会议
                    </div>
                    <div class="btn" v-if="(lessonInfo.status===2||lessonInfo.status===4)
                            && lessonInfo.role === 0" @click="handleStop">
                        停止协同
                    </div>
                    <div class="btn" v-if="(lessonInfo.status===1||lessonInfo.status===2||lessonInfo.status===3||lessonInfo.status===4)&& lessonInfo.role === 0" @click="editLesson">
                        编辑
                    </div>
                    <div class="btn" v-if="lessonInfo.status===9&& lessonInfo.role === 0&&(lessonInfo.releaseStatus===0||lessonInfo.releaseStatus===3)" @click="handleRelease">
                        发布备课
                    </div>
                </div>
            </div>
            <div class="base-info-container">
                <div class="base-info-content">
                    <div class="info-lesson-title">
                        [协同备课]{{lessonInfo.title}}
                    </div>
                    <div class="info-item-column" style="margin-top: 10px">
                        <div class="info-item-subject">学科信息：{{lessonInfo.periodName}}、{{lessonInfo.gradeName}}、{{lessonInfo.subjectName}}</div>
                        <div class="info-item-level">备课性质：
                            <span v-if="lessonInfo.lessonNature === '1'">普通</span>
                            <span v-if="lessonInfo.lessonNature === '2'">名师工作室</span>
                            <span v-if="lessonInfo.lessonNature === '3'">名校长工作室</span>
                            <span v-if="lessonInfo.lessonNature === '4'">群组任务</span>
                        </div>
                        <div class="info-item-level">备课级别：{{lessonInfo.lessonLevelName}}</div>
                    </div>
                    <div class="info-item-column">
                        备课时段：{{ timestampToTime(lessonInfo.beginTime)}}至{{ timestampToTime(lessonInfo.endTime)}}
                    </div>
                    <div class="info-item-column" v-if="lessonInfo.discussMode!==0">
                        备课研讨：
                        <span v-if="lessonInfo.discussMode === 1">一轮研讨</span>
                        <span v-if="lessonInfo.discussMode === 2">二轮研讨</span>
                    </div>
                    <div class="lesson-team-code-container">
                        <div class="lesson-team-item">
                            <div class="lesson-user">
                                <div class="lesson-lead">主备人：{{lessonInfo.leadUserName}}</div>
                                <div class="lesson-guide" v-if="lessonInfo.guideNames">指导专家：{{lessonInfo.guideNames}}</div>
                            </div>
                            <div class="lesson-team">
                                协备人：{{lessonInfo.teamUserNames}}
                            </div>
                        </div>

                        <div class="lesson-code-item"
                             v-if="(lessonInfo.status===2||lessonInfo.status===3||lessonInfo.status===4)&& lessonInfo.role === 0">
                            <div class="code-container">
                                <div class="code-title">协备邀请码</div>
                                <div class="cursor" @click="handleXbDownload">
                                    <el-tooltip
                                      class="box-item"
                                      effect="dark"
                                      content="点击下载二维码"
                                      placement="bottom">
                                        <vueQr ref="xbcode" :text="qrCode.shareUrl"
                                               :size="qrCode.size"
                                               :margin="qrCode.margin"/>
                                    </el-tooltip>
                                </div>
                            </div>
                            <div class="code-container">
                                <div class="code-title">专家邀请码</div>
                                <div class="cursor" @click="handleZjDownload">
                                    <el-tooltip
                                      class="box-item"
                                      effect="dark"
                                      content="点击下载二维码"
                                      placement="bottom">
                                        <vueQr ref="zjcode" :text="qrCode.shareZjUrl"
                                               :size="qrCode.size"
                                               :margin="qrCode.margin"/>
                                    </el-tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="base-info-cover">
                    <img class="img-100"  :src="lessonInfo.coverUrl" alt="">
                </div>
            </div>
            <!-- 时间进度安排-->
            <div class="lesson-time-container"  v-if="this.isTime===1&&this.isTimeShow&&lessonInfo.discussMode!==0">
                <div class="topic-time-top">
                    <div class="topic-time-top1">
                        <svg t="1745994882084" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9405" width="18" height="18"><path d="M597.333333 618.666667h149.333334c25.6 0 42.666667-17.066667 42.666666-42.666667s-17.066667-42.666667-42.666666-42.666667H597.333333c-25.6 0-42.666667 17.066667-42.666666 42.666667s17.066667 42.666667 42.666666 42.666667zM597.333333 832h149.333334c25.6 0 42.666667-17.066667 42.666666-42.666667s-17.066667-42.666667-42.666666-42.666666H597.333333c-25.6 0-42.666667 17.066667-42.666666 42.666666s17.066667 42.666667 42.666666 42.666667zM277.333333 618.666667H426.666667c25.6 0 42.666667-17.066667 42.666666-42.666667s-17.066667-42.666667-42.666666-42.666667H277.333333c-25.6 0-42.666667 17.066667-42.666666 42.666667s17.066667 42.666667 42.666666 42.666667zM277.333333 832H426.666667c25.6 0 42.666667-17.066667 42.666666-42.666667s-17.066667-42.666667-42.666666-42.666666H277.333333c-25.6 0-42.666667 17.066667-42.666666 42.666666s17.066667 42.666667 42.666666 42.666667z" p-id="9406" fill="#3b62f8"></path><path d="M874.666667 85.333333h-128V42.666667c0-25.6-17.066667-42.666667-42.666667-42.666667s-42.666667 17.066667-42.666667 42.666667v42.666666h-298.666666V42.666667c0-25.6-17.066667-42.666667-42.666667-42.666667s-42.666667 17.066667-42.666667 42.666667v42.666666h-128C89.6 85.333333 42.666667 132.266667 42.666667 192v725.333333C42.666667 977.066667 89.6 1024 149.333333 1024h725.333334c59.733333 0 106.666667-46.933333 106.666666-106.666667v-725.333333C981.333333 132.266667 934.4 85.333333 874.666667 85.333333zM128 192c0-12.8 8.533333-21.333333 21.333333-21.333333h128v42.666666c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666667-42.666667V170.666667h298.666666v42.666666c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666667-42.666667V170.666667h128c12.8 0 21.333333 8.533333 21.333333 21.333333V341.333333H128V192z m768 725.333333c0 12.8-8.533333 21.333333-21.333333 21.333334h-725.333334c-12.8 0-21.333333-8.533333-21.333333-21.333334V426.666667h768v490.666666z" p-id="9407" fill="#3b62f8"></path></svg>
                    </div>
                    <div class="topic-time-top2">
                        协同备课时间进度
                    </div>
                </div>
                <!--上传初案 1-未开始 2-进行中 3-已完成-->
                <div :class="judgeLessonStatus(1,lessonInfo.status)===1?'lesson-time-item-container status-wks':judgeLessonStatus(1,lessonInfo.status)===2?'lesson-time-item-container status-jxz':'lesson-time-item-container status-ywc'">
                    <div class="lesson-time-info-container">
                        <div :class="judgeLessonStatus(1,lessonInfo.status)===1?'lesson-time-yd bg-wks':judgeLessonStatus(1,lessonInfo.status)===2?'lesson-time-yd bg-jxz':'lesson-time-yd bg-ywc'"></div>
                        <div class="lesson-time-info">
                            <div class="lesson-status-title">上传初案</div>
                            <div class="lesson-status-time">开始时间：{{ timestampToTime(lessonInfo.beginTime)}}</div>
                            <div class="lesson-status-time">完成时间：{{ timestampToTime(lessonInfo.firstDiscussBeginTime)}}</div>
                        </div>
                        <div class="lesson-time-operation">
                            <div v-if="judgeLessonStatus(1,lessonInfo.status)===2" class="operation-btn border-jxz1">进行中</div>
                            <div v-if="judgeLessonStatus(1,lessonInfo.status)===3" class="operation-btn border-ywc1">已完成</div>
                        </div>
                    </div>
                    <div :class="judgeLessonStatus(1,lessonInfo.status)===1?'lesson-time-line-container border-wks2':judgeLessonStatus(1,lessonInfo.status)===2?'lesson-time-line-container border-jxz2':'lesson-time-line-container border-ywc2'"></div>
                </div>
                <!--一轮研讨-->
                <div :class="judgeLessonStatus(2,lessonInfo.status)===1?'lesson-time-item-container status-wks':judgeLessonStatus(2,lessonInfo.status)===2?'lesson-time-item-container status-jxz':'lesson-time-item-container status-ywc'">
                    <div class="lesson-time-info-container">
                        <div :class="judgeLessonStatus(2,lessonInfo.status)===1?'lesson-time-yd bg-wks':judgeLessonStatus(2,lessonInfo.status)===2?'lesson-time-yd bg-jxz':'lesson-time-yd bg-ywc'"></div>
                        <div class="lesson-time-info">
                            <div class="lesson-status-title">一轮研讨</div>
                            <div class="lesson-status-time">开始时间：{{ timestampToTime(lessonInfo.firstDiscussBeginTime)}}</div>
                            <div class="lesson-status-time">完成时间：{{ timestampToTime(lessonInfo.firstDiscussEndTime)}}</div>
                            <div class="lesson-status-join-tea">参与教师：{{this.oneDiscussList.length}}人提交</div>
                            <div v-if="lessonInfo.role === 0" :class="judgeLessonStatus(2,lessonInfo.status)===1?'lesson-status-join-info cursor':'lesson-status-join-info-active cursor'"  @click="viewDiscussDetail(1)">详细名单</div>
                        </div>
                        <div class="lesson-time-operation">
                            <div v-if="judgeLessonStatus(2,lessonInfo.status)===2" class="operation-btn border-jxz1">进行中</div>
                            <div v-if="judgeLessonStatus(2,lessonInfo.status)===3" class="operation-btn border-ywc1">已完成</div>
                            <div v-if="judgeLessonStatus(2,lessonInfo.status)!==1&& lessonInfo.role !== 2" class="operation-btn border-ywc1" @click="handleDiscussMode(1)">查看详情</div>
                        </div>
                    </div>
                    <div :class="judgeLessonStatus(2,lessonInfo.status)===1?'lesson-time-line-container border-wks2':judgeLessonStatus(2,lessonInfo.status)===2?'lesson-time-line-container border-jxz2':'lesson-time-line-container border-ywc2'"></div>
                </div>
                <!--一轮上传共案-->
                <div v-if="lessonInfo.discussMode===1" :class="judgeLessonStatus(3,lessonInfo.status)===1?'lesson-time-item-container status-wks':judgeLessonStatus(3,lessonInfo.status)===2?'lesson-time-item-container status-jxz':'lesson-time-item-container status-ywc'">
                    <div class="lesson-time-info-container">
                        <div :class="judgeLessonStatus(3,lessonInfo.status)===1?'lesson-time-yd bg-wks':judgeLessonStatus(3,lessonInfo.status)===2?'lesson-time-yd bg-jxz':'lesson-time-yd bg-ywc'"></div>
                        <div class="lesson-time-info">
                            <div class="lesson-status-title">上传共案</div>
                            <div class="lesson-status-time">开始时间：{{ timestampToTime(lessonInfo.firstDiscussEndTime)}}</div>
                            <div class="lesson-status-time">完成时间：{{ timestampToTime(lessonInfo.gaFinishTime)}}</div>
                        </div>
                        <div class="lesson-time-operation">
                            <div v-if="judgeLessonStatus(3,lessonInfo.status)===2" class="operation-btn border-jxz1">进行中</div>
                            <div v-if="judgeLessonStatus(3,lessonInfo.status)===3" class="operation-btn border-ywc1">已完成</div>
                        </div>
                    </div>
                    <div :class="judgeLessonStatus(3,lessonInfo.status)===1?'lesson-time-line-container border-wks2':judgeLessonStatus(3,lessonInfo.status)===2?'lesson-time-line-container border-jxz2':'lesson-time-line-container border-ywc2'"></div>
                </div>
                <!--初案修正-->
                <div v-if="lessonInfo.discussMode===2" :class="judgeLessonStatus(3,lessonInfo.status)===1?'lesson-time-item-container status-wks':judgeLessonStatus(3,lessonInfo.status)===2?'lesson-time-item-container status-jxz':'lesson-time-item-container status-ywc'">
                    <div class="lesson-time-info-container">
                        <div :class="judgeLessonStatus(3,lessonInfo.status)===1?'lesson-time-yd bg-wks':judgeLessonStatus(3,lessonInfo.status)===2?'lesson-time-yd bg-jxz':'lesson-time-yd bg-ywc'"></div>
                        <div class="lesson-time-info">
                            <div class="lesson-status-title">初案修正</div>
                            <div class="lesson-status-time">开始时间：{{ timestampToTime(lessonInfo.firstDiscussEndTime)}}</div>
                            <div class="lesson-status-time">完成时间：{{ timestampToTime(lessonInfo.secondDiscussBeginTime)}}</div>
                        </div>
                        <div class="lesson-time-operation">
                            <div v-if="judgeLessonStatus(3,lessonInfo.status)===2" class="operation-btn border-jxz1">进行中</div>
                            <div v-if="judgeLessonStatus(3,lessonInfo.status)===3" class="operation-btn border-ywc1">已完成</div>
                        </div>
                    </div>
                    <div :class="judgeLessonStatus(3,lessonInfo.status)===1?'lesson-time-line-container border-wks2':judgeLessonStatus(3,lessonInfo.status)===2?'lesson-time-line-container border-jxz2':'lesson-time-line-container border-ywc2'"></div>
                </div>
                <!--二轮研讨-->
                <div v-if="lessonInfo.discussMode===2" :class="judgeLessonStatus(4,lessonInfo.status)===1?'lesson-time-item-container status-wks':judgeLessonStatus(4,lessonInfo.status)===2?'lesson-time-item-container status-jxz':'lesson-time-item-container status-ywc'">
                    <div class="lesson-time-info-container">
                        <div :class="judgeLessonStatus(4,lessonInfo.status)===1?'lesson-time-yd bg-wks':judgeLessonStatus(4,lessonInfo.status)===2?'lesson-time-yd bg-jxz':'lesson-time-yd bg-ywc'"></div>
                        <div class="lesson-time-info">
                            <div class="lesson-status-title">二轮研讨</div>
                            <div class="lesson-status-time">开始时间：{{ timestampToTime(lessonInfo.secondDiscussBeginTime)}}</div>
                            <div class="lesson-status-time">完成时间：{{ timestampToTime(lessonInfo.secondDiscussEndTime)}}</div>
                            <div class="lesson-status-join-tea">参与教师：{{this.twoDiscussList.length}}人提交</div>
                            <div v-if="lessonInfo.role === 0" :class="judgeLessonStatus(4,lessonInfo.status)===1?'lesson-status-join-info cursor':'lesson-status-join-info-active cursor'"  @click="viewDiscussDetail(2)">详细名单</div>
                        </div>
                        <div class="lesson-time-operation">
                            <div v-if="judgeLessonStatus(4,lessonInfo.status)===2" class="operation-btn border-jxz1">进行中</div>
                            <div v-if="judgeLessonStatus(4,lessonInfo.status)===3" class="operation-btn border-ywc1">已完成</div>
                            <div v-if="judgeLessonStatus(4,lessonInfo.status)!==1&& lessonInfo.role !== 2" class="operation-btn border-ywc1" @click="handleDiscussMode(2)">查看详情</div>
                        </div>
                    </div>
                    <div class="lesson-time-line-container border-wks2"></div>
                </div>
                <!--二轮上传共案-->
                <div v-if="lessonInfo.discussMode===2" :class="judgeLessonStatus(5,lessonInfo.status)===1?'lesson-time-item-container status-wks':judgeLessonStatus(5,lessonInfo.status)===2?'lesson-time-item-container status-jxz':'lesson-time-item-container status-ywc'">
                    <div class="lesson-time-info-container">
                        <div :class="judgeLessonStatus(5,lessonInfo.status)===1?'lesson-time-yd bg-wks':judgeLessonStatus(5,lessonInfo.status)===2?'lesson-time-yd bg-jxz':'lesson-time-yd bg-ywc'"></div>
                        <div class="lesson-time-info">
                            <div class="lesson-status-title">上传共案</div>
                            <div class="lesson-status-time">开始时间：{{ timestampToTime(lessonInfo.secondDiscussEndTime)}}</div>
                            <div class="lesson-status-time">完成时间：{{ timestampToTime(lessonInfo.gaFinishTime)}}</div>
                        </div>
                        <div class="lesson-time-operation">
                            <div v-if="judgeLessonStatus(5,lessonInfo.status)===2" class="operation-btn border-jxz1">进行中</div>
                            <div v-if="judgeLessonStatus(5,lessonInfo.status)===3" class="operation-btn border-ywc1">已完成</div>
                        </div>
                    </div>
                    <div :class="judgeLessonStatus(5,lessonInfo.status)===1?'lesson-time-line-container border-wks2':judgeLessonStatus(5,lessonInfo.status)===2?'lesson-time-line-container border-jxz2':'lesson-time-line-container border-ywc2'"></div>
                </div>
                <!--教学反思-->
                <div :class="judgeLessonStatus(8,lessonInfo.status)===1?'lesson-time-item-container status-wks':judgeLessonStatus(8,lessonInfo.status)===2?'lesson-time-item-container status-jxz':'lesson-time-item-container status-ywc'">
                    <div class="lesson-time-info-container">
                        <div :class="judgeLessonStatus(8,lessonInfo.status)===1?'lesson-time-yd bg-wks':judgeLessonStatus(8,lessonInfo.status)===2?'lesson-time-yd bg-jxz':'lesson-time-yd bg-ywc'"></div>
                        <div class="lesson-time-info">
                            <div class="lesson-status-title">教学反思</div>
                            <div class="lesson-status-time">开始时间：{{ timestampToTime(lessonInfo.gaFinishTime)}}</div>
                            <div class="lesson-status-time">完成时间：{{ timestampToTime(lessonInfo.finishTime)}}</div>
                            <div :class="judgeLessonStatus(8,lessonInfo.status)===1?'lesson-status-join-tea':'lesson-status-join-tea'">参与教师：{{lessonInfo.refCount}}人提交</div>
                            <div v-if="lessonInfo.role === 0" :class="judgeLessonStatus(8,lessonInfo.status)===1?'lesson-status-join-info cursor':'lesson-status-join-info-active cursor'"  @click="viewRefDetail">详细名单</div>
                        </div>
                        <div class="lesson-time-operation">
                            <div v-if="judgeLessonStatus(8,lessonInfo.status)===2" class="operation-btn border-jxz1">进行中</div>
                            <div v-if="judgeLessonStatus(8,lessonInfo.status)===3" class="operation-btn border-ywc1">已完成</div>
                            <div v-if="judgeLessonStatus(8,lessonInfo.status)!==1&& lessonInfo.role === 0" class="operation-btn border-ywc1" @click="viewRefDetail">查看详情</div>
                        </div>
                    </div>
                    <div :class="judgeLessonStatus(8,lessonInfo.status)===1?'lesson-time-line-container border-wks2':judgeLessonStatus(8,lessonInfo.status)===2?'lesson-time-line-container border-jxz2':'lesson-time-line-container border-ywc2'"></div>
                </div>
                <!--备课完成-->
                <div :class="lessonInfo.status!==9?'lesson-time-item-container status-wks':'lesson-time-item-container status-ywc'">
                    <div class="lesson-time-info-container">
                        <div :class="lessonInfo.status!==9?'lesson-time-yd bg-wks':'lesson-time-yd bg-ywc'"></div>
                        <div class="lesson-time-info">
                            <div class="lesson-status-title">备课完成</div>
                            <div class="lesson-status-time">完成时间：{{ timestampToTime(lessonInfo.finishTime)}}</div>

                        </div>
                        <div class="lesson-time-operation">
                        </div>
                    </div>
                </div>
            </div>

            <div class="info-column-container">
                <div class="column-title">附件内容</div>
            </div>
            <!--初案-->
            <div class="file-classify-container"
                 v-if="(jaFiles&&jaFiles.length>0)||
                 (xaFiles&&xaFiles.length>0)||
                 (kjFiles&&kjFiles.length>0)||
                 (xtFiles&&xtFiles.length>0)">
                <div class="top-file-classify">初案</div>
            </div>
            <div class="file-info-container">
                <!--教案-->
                <div class="file-container" v-if="jaFiles&&jaFiles.length>0">
                    <div class="file-type">
                        <div class="file-classify">教案</div>
                    </div>
                    <div class="file-list">
                        <div class="file-item" v-for="item in jaFiles" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view" v-if="!judgeIsPPT(item.fileType)">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                </el-image>
                            </div>
                            <div class="file-view" v-if="judgeIsPPT(item.fileType)">
                                <el-image @click="viewPPTFile(item.fileUrl)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/ppt_play.png')">
                                </el-image>
                            </div>
                            <div class="file-download">
                                <img class="file-icon" @click="downloadFile(item)" src="../../assets/file/file_download.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <!--学案-->
                <div class="file-container" v-if="xaFiles&&xaFiles.length>0">
                    <div class="file-type">
                        <div class="file-classify">学案</div>
                    </div>
                    <div class="file-list">
                        <div class="file-item" v-for="item in xaFiles" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view" v-if="!judgeIsPPT(item.fileType)">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                </el-image>
                            </div>
                            <div class="file-view" v-if="judgeIsPPT(item.fileType)">
                                <el-image @click="viewPPTFile(item.fileUrl)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/ppt_play.png')">
                                </el-image>
                            </div>
                            <div class="file-download">
                                <img class="file-icon" @click="downloadFile(item)" src="../../assets/file/file_download.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <!--课件-->
                <div class="file-container" v-if="kjFiles&&kjFiles.length>0">
                    <div class="file-type">
                        <div class="file-classify">课件</div>
                    </div>
                    <div class="file-list">
                        <div class="file-item" v-for="item in kjFiles" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view" v-if="!judgeIsPPT(item.fileType)">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                </el-image>
                            </div>
                            <div class="file-view" v-if="judgeIsPPT(item.fileType)">
                                <el-image @click="viewPPTFile(item.fileUrl)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/ppt_play.png')">
                                </el-image>
                            </div>
                            <div class="file-download">
                                <img class="file-icon" @click="downloadFile(item)" src="../../assets/file/file_download.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <!--习题-->
                <div class="file-container" v-if="xtFiles&&xtFiles.length>0">
                    <div class="file-type">
                        <div class="file-classify">习题</div>
                    </div>
                    <div class="file-list">
                        <div class="file-item" v-for="item in xtFiles" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view" v-if="!judgeIsPPT(item.fileType)">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                </el-image>
                            </div>
                            <div class="file-view" v-if="judgeIsPPT(item.fileType)">
                                <el-image @click="viewPPTFile(item.fileUrl)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/ppt_play.png')">
                                </el-image>
                            </div>
                            <div class="file-download">
                                <img class="file-icon" @click="downloadFile(item)" src="../../assets/file/file_download.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--修正案-->
            <div class="file-classify-container"
                 v-if="((ytjaFiles&&ytjaFiles.length>0)||
                 (ytxaFiles&&ytxaFiles.length>0)||
                 (ytkjFiles&&ytkjFiles.length>0)||
                 (ytxtFiles&&ytxtFiles.length>0))&&lessonInfo.discussMode===2">
                <div class="top-file-classify">修正案</div>
            </div>
            <div class="file-info-container"
                 v-if="((ytjaFiles&&ytjaFiles.length>0)||
                 (ytxaFiles&&ytxaFiles.length>0)||
                 (ytkjFiles&&ytkjFiles.length>0)||
                 (ytxtFiles&&ytxtFiles.length>0))&&lessonInfo.discussMode===2">
                <!--教案-->
                <div class="file-container" v-if="ytjaFiles&&ytjaFiles.length>0">
                    <div class="file-type">
                        <div class="file-classify">教案</div>
                    </div>
                    <div class="file-list">
                        <div class="file-item" v-for="item in ytjaFiles" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view" v-if="!judgeIsPPT(item.fileType)">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                </el-image>
                            </div>
                            <div class="file-view" v-if="judgeIsPPT(item.fileType)">
                                <el-image @click="viewPPTFile(item.fileUrl)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/ppt_play.png')">
                                </el-image>
                            </div>
                            <div class="file-download">
                                <img class="file-icon" @click="downloadFile(item)" src="../../assets/file/file_download.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <!--学案-->
                <div class="file-container" v-if="ytxaFiles&&ytxaFiles.length>0">
                    <div class="file-type">
                        <div class="file-classify">学案</div>
                    </div>
                    <div class="file-list">
                        <div class="file-item" v-for="item in ytxaFiles" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view" v-if="!judgeIsPPT(item.fileType)">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                </el-image>
                            </div>
                            <div class="file-view" v-if="judgeIsPPT(item.fileType)">
                                <el-image @click="viewPPTFile(item.fileUrl)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/ppt_play.png')">
                                </el-image>
                            </div>
                            <div class="file-download">
                                <img class="file-icon" @click="downloadFile(item)" src="../../assets/file/file_download.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <!--课件-->
                <div class="file-container" v-if="ytkjFiles&&ytkjFiles.length>0">
                    <div class="file-type">
                        <div class="file-classify">课件</div>
                    </div>
                    <div class="file-list">
                        <div class="file-item" v-for="item in ytkjFiles" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view" v-if="!judgeIsPPT(item.fileType)">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                </el-image>
                            </div>
                            <div class="file-view" v-if="judgeIsPPT(item.fileType)">
                                <el-image @click="viewPPTFile(item.fileUrl)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/ppt_play.png')">
                                </el-image>
                            </div>
                            <div class="file-download">
                                <img class="file-icon" @click="downloadFile(item)" src="../../assets/file/file_download.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <!--习题-->
                <div class="file-container" v-if="ytxtFiles&&ytxtFiles.length>0">
                    <div class="file-type">
                        <div class="file-classify">习题</div>
                    </div>
                    <div class="file-list">
                        <div class="file-item" v-for="item in ytxtFiles" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view" v-if="!judgeIsPPT(item.fileType)">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                </el-image>
                            </div>
                            <div class="file-view" v-if="judgeIsPPT(item.fileType)">
                                <el-image @click="viewPPTFile(item.fileUrl)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/ppt_play.png')">
                                </el-image>
                            </div>
                            <div class="file-download">
                                <img class="file-icon" @click="downloadFile(item)" src="../../assets/file/file_download.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--共案-->
            <div class="file-classify-container"
                 v-if="(gajaFiles&&gajaFiles.length>0)||
                 (gaxaFiles&&gaxaFiles.length>0)||
                 (gakjFiles&&gakjFiles.length>0)||
                 (gaxtFiles&&gaxtFiles.length>0)">
                <div class="top-file-classify">共案</div>
            </div>
            <div class="file-info-container">
                <!--教案-->
                <div class="file-container" v-if="gajaFiles&&gajaFiles.length>0">
                    <div class="file-type">
                        <div class="file-classify">教案</div>
                    </div>
                    <div class="file-list">
                        <div class="file-item" v-for="item in gajaFiles" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view" v-if="!judgeIsPPT(item.fileType)">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                </el-image>
                            </div>
                            <div class="file-view" v-if="judgeIsPPT(item.fileType)">
                                <el-image @click="viewPPTFile(item.fileUrl)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/ppt_play.png')">
                                </el-image>
                            </div>
                            <div class="file-download">
                                <img class="file-icon" @click="downloadFile(item)" src="../../assets/file/file_download.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <!--学案-->
                <div class="file-container" v-if="gaxaFiles&&gaxaFiles.length>0">
                    <div class="file-type">
                        <div class="file-classify">学案</div>
                    </div>
                    <div class="file-list">
                        <div class="file-item" v-for="item in gaxaFiles" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view" v-if="!judgeIsPPT(item.fileType)">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                </el-image>
                            </div>
                            <div class="file-view" v-if="judgeIsPPT(item.fileType)">
                                <el-image @click="viewPPTFile(item.fileUrl)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/ppt_play.png')">
                                </el-image>
                            </div>
                            <div class="file-download">
                                <img class="file-icon" @click="downloadFile(item)" src="../../assets/file/file_download.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <!--课件-->
                <div class="file-container" v-if="gakjFiles&&gakjFiles.length>0">
                    <div class="file-type">
                        <div class="file-classify">课件</div>
                    </div>
                    <div class="file-list">
                        <div class="file-item" v-for="item in gakjFiles" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view" v-if="!judgeIsPPT(item.fileType)">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                </el-image>
                            </div>
                            <div class="file-view" v-if="judgeIsPPT(item.fileType)">
                                <el-image @click="viewPPTFile(item.fileUrl)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/ppt_play.png')">
                                </el-image>
                            </div>
                            <div class="file-download">
                                <img class="file-icon" @click="downloadFile(item)" src="../../assets/file/file_download.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <!--习题-->
                <div class="file-container" v-if="gaxtFiles&&gaxtFiles.length>0">
                    <div class="file-type">
                        <div class="file-classify">习题</div>
                    </div>
                    <div class="file-list">
                        <div class="file-item" v-for="item in gaxtFiles" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view" v-if="!judgeIsPPT(item.fileType)">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                </el-image>
                            </div>
                            <div class="file-view" v-if="judgeIsPPT(item.fileType)">
                                <el-image @click="viewPPTFile(item.fileUrl)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/ppt_play.png')">
                                </el-image>
                            </div>
                            <div class="file-download">
                                <img class="file-icon" @click="downloadFile(item)" src="../../assets/file/file_download.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!--编辑-->
        <div class="lesson-container" v-show="this.showMode==='edit'">
            <div class="top-title">编辑协同备课</div>
            <el-form ref="form" :model="lessonInfo" :rules="rules" label-width="100px">
                <div class="info-column-container">
                    <div class="column-title">基本信息</div>
                </div>
                <el-row class="mt10">
                    <el-col :span="8">
                        <el-form-item label="学段" prop="periodKey">
                            <el-select @change="changePeriod" v-model="lessonInfo.periodKey" placeholder="请选择学段">
                                <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="年级" prop="gradeKey">
                            <el-select @change="changeGrade" v-model="lessonInfo.gradeKey" placeholder="请选择年级">
                                <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="学科" prop="subjectKey">
                            <el-select v-model="lessonInfo.subjectKey" placeholder="请选择学科">
                                <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="mt10">
                    <el-col :span="16">
                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="备课标题" prop="title">
                                    <el-input v-model="lessonInfo.title" placeholder="请输入备课标题"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-icon @click="queryDirectory" class="cursor" :size="24" style="margin-top: 3px;margin-left: 7px;">
                                    <Notebook></Notebook>
                                </el-icon>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="备课性质" prop="lessonNature">
                                    <el-select @change="changeLessonNature" style="width: 100%;" v-model="lessonInfo.lessonNature"
                                               placeholder="请选择备课性质">
                                        <el-option v-for="item in natureList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="lessonInfo.lessonNature != '1'">
                            <el-col :span="12">
                                <el-form-item :label="lessonInfo.lessonNature == 4 ? '群组' : '工作室'" prop="groupId">
                                    <el-select @change="changeQun" style="width: 100%;" v-model="lessonInfo.groupId"
                                               placeholder="请选择工作室/群组">
                                        <el-option v-for="item in groupList" :key="item.groupId" :label="item.groupName"
                                                   :value="item.groupId" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="课题级别" prop="lessonLevelKey">
                                    <el-select style="width: 100%;" v-model="lessonInfo.lessonLevelKey" placeholder="请选择课题级别">
                                        <el-option v-for="item in lessonLevelList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="主备人" prop="leadUser">
                                    <choosePeople :showTitle="'选择人员'" @gxDisable="gxDisable" :radio="true" ref="leadUser" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="封面" prop="coverUrl">
                            <el-upload class="avatar-uploader"
                                       :action="serviceUrl+'/businessservice/lesson/uploadGrCover'"
                                       :show-file-list="false" :on-success="handleCoverSuccess" :headers="{ token }"
                                       :before-upload="beforeCoverUpload">
                                <img v-if="lessonInfo.coverUrl" :src="lessonInfo.coverUrl" class="avatar" style="position:absolute" />
                                <el-icon v-else class="avatar-uploader-icon" style="font-size:100px;color:#fff;">
                                    <Plus />
                                </el-icon>
                            </el-upload>
                            <div style="color: #a9abad;width:100%;">推荐使用540*304尺寸的图片</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="协备人员" prop="teamuseList">
                            <choosePeople :showTitle="'选择人员'" @gxDisable="gxDisable" ref="teamuseList" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="指导专家" prop="guideUsersList">
                            <choosePeople isTsExpertList :showTitle="'选择人员'" @gxDisable="gxDisable" ref="guideUsersList" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="disflex-row-center">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>

        <el-dialog title="课程目录" v-model="isDirectory" width="60%">
            <el-row>
                <el-empty v-if="directoryList.length == 0" style="margin: 0 auto;" description="暂无数据" />
                <div style="margin-bottom: 15px;margin-right:40px;" v-for="item in directoryList">
                    <el-card @click="goCourse(item)" class="cursor" style="width: 150px;">
                        <div class="csbbb">
                            <el-image fit="cover" style="width: 130px;height:185px" :src="item.coverUrl"></el-image>
                        </div>
                        <div class="mt5 text-one">{{ item.className }}</div>
                    </el-card>
                </div>
            </el-row>
        </el-dialog>

        <el-dialog title="课程目录" v-model="isCourse" width="60%">
            <el-table :data="tableData" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px">
                <el-table-column prop="ptit" label="单元名" width="180">
                    <template #default="scope">
                        <div style="display: flex;justify-content: space-between;">
                            <div @click="changeTitle(scope.row)" :style="scope.row.title ? '' : 'color: #409efe;'"
                                 :class="scope.row.title ? '' : 'cursor'" :title="scope.row.ptit" style="" class="text-one ">
                                {{ scope.row.ptit }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="课程名">
                    <template #default="scope">
                        <div style="display: flex;justify-content: space-between;" v-if="scope.row.id">
                            <div @click="changeTitle(scope.row)" :title="scope.row.title" style="color: #409efe;"
                                 class="text-one cursor">
                                {{ scope.row.title }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog title="上传初案" v-model="uploadCa" width="40%" @close="queryLessonInfo()">
            <el-form ref="lessonFileForm" :model="lessonInfo" label-width="100px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="教案" prop="title">
                            <el-upload v-if="!loading" v-model:file-list="jAFileList" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'" :headers="{ token }"
                                       :on-remove="handleRemove"
                                       :data="{ fileType: 1, lessonType: 0, lessionId: this.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="学案" prop="title">
                            <el-upload v-if="!loading" v-model:file-list="xAFileList" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'" :headers="{ token }"
                                       :on-remove="handleRemove"
                                       :data="{ fileType: 4, lessonType: 0, lessionId: this.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="课件" prop="title">
                            <el-upload v-if="!loading" v-model:file-list="kJFileList" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'" :headers="{ token }"
                                       :on-remove="handleRemove"
                                       :data="{ fileType: 2, lessonType: 0, lessionId: this.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="习题" prop="title">
                            <el-upload v-if="!loading" v-model:file-list="xTFileList"
                                       class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'"
                                       :headers="{ token }"
                                       :on-remove="handleRemove"
                                       :data="{ fileType: 3, lessonType: 0, lessionId: this.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <el-dialog title="上传修正案" v-model="uploadXza" width="40%" @close="queryLessonInfo()">
            <el-form ref="lessonFileForm" :model="lessonInfo" label-width="100px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="教案" prop="title">
                            <el-upload v-if="!loading" v-model:file-list="ytjAFileList" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'" :headers="{ token }"
                                       :on-remove="handleRemove"
                                       :data="{ fileType: 1, lessonType: 2, lessionId: this.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="学案" prop="title">
                            <el-upload v-if="!loading" v-model:file-list="ytxAFileList" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'" :headers="{ token }"
                                       :on-remove="handleRemove"
                                       :data="{ fileType: 4, lessonType: 2, lessionId: this.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="课件" prop="title">
                            <el-upload v-if="!loading" v-model:file-list="ytkJFileList" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'" :headers="{ token }"
                                       :on-remove="handleRemove"
                                       :data="{ fileType: 2, lessonType: 2, lessionId: this.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="习题" prop="title">
                            <el-upload v-if="!loading" v-model:file-list="ytxTFileList" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'" :headers="{ token }"
                                       :on-remove="handleRemove"
                                       :data="{ fileType: 3, lessonType: 2, lessionId: this.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <el-dialog title="上传共案" v-model="uploadGa" width="40%" @close="queryLessonInfo()">
            <el-form ref="lessonFileForm" :model="lessonInfo" label-width="100px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="共案封面" prop="bannerUrl">
                            <el-upload class="avatar-uploader"
                                       :action="serviceUrl+'/businessservice/lesson/uploadCover'" :show-file-list="false"
                                       :on-success="handleAvatarSuccess" :headers="{ token }"
                                       :data="{ lessonId: this.lessonId }" :before-upload="beforeAvatarUpload">
                                <img v-if="lessonInfo.coverUrl" :src="lessonInfo.coverUrl" class="avatar"
                                     style="position:absolute" alt=/>
                                <el-icon class="avatar-uploader-icon" style="font-size:100px;">
                                    <Plus />
                                </el-icon>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="教案" prop="title">
                            <el-upload v-if="!loading" v-model:file-list="gajAFileList" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'"
                                       :headers="{ token }"
                                       :on-remove="handleRemove"
                                       :data="{ fileType: 1, lessonType: 1, lessionId: this.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="学案" prop="title">
                            <el-upload v-if="!loading" v-model:file-list="gaxAFileList" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'"
                                       :headers="{ token }" :on-remove="handleRemove"
                                       :data="{ fileType: 4, lessonType: 1, lessionId: this.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="课件" prop="title">
                            <el-upload v-if="!loading" v-model:file-list="gakJFileList" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'"
                                       :headers="{ token }" :on-remove="handleRemove"
                                       :data="{ fileType: 2, lessonType: 1, lessionId: this.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="习题" prop="title">
                            <el-upload v-if="!loading" v-model:file-list="gaxTFileList" class="upload-demo"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'"
                                       :headers="{ token }" :on-remove="handleRemove"
                                       :data="{ fileType: 3, lessonType: 1, lessionId: this.lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <el-dialog title="发起备课会议" v-model="meetingDisable" width="400px">
            <el-form ref="meetingFormRef" :rules="meetingFormRules" :model="meetingForm" label-width="100px" class="meeting-form">
                <el-row>
                    <el-form-item class="pull-right" label="腾讯会议号" prop="meetingCode">
                        <el-input v-model="meetingForm.meetingCode"
                                  style="width: 200px;"
                                  placeholder="请输入腾讯会议号" >
                        </el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item class="pull-right" label="会议时间" prop="meetingTime">
                        <el-date-picker
                          v-model="meetingForm.meetingTime"
                          type="datetime"
                          style="width: 200px;"
                          format="YYYY-MM-DD HH:mm"
                          placeholder="请选择腾讯会议开始时间"
                          clearable/>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item>
                        <el-button type="primary" @click="subMeeting">确定</el-button>
                        <el-button @click="cancelMeeting">取消</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </el-dialog>
        <!--发布-->
        <el-dialog class="zdylesson" title="查看人员" v-model="ckPeople" width="60%">
            <choosePeople :noShowIdList="noShowIdList" v-if="ckPeople"
                          :showTitle="'选择人员'"
                          ref="ckPeople" />
            <div class="mt5" style="color: red;">*主备人、协备人、指导专家默认可查看。</div>
            <template #footer>
                <div class="disflex-row-center">
                    <el-button type="primary" @click="submitCkPeopleForm">确 定</el-button>
                    <el-button @click="closeCkPeople">取 消</el-button>
                </div>
            </template>
        </el-dialog>

        <!--上传反思-->
        <el-dialog title="教学反思" v-model="isShowReflection" width="35%">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="反思文件" prop="title">
                        <el-upload v-if="!loading" v-model:file-list="refFileList"
                                   class="upload-demo"
                                   :action="serviceUrl+'/businessservice/reflection/uploadFile'"
                                   :headers="{ token }"
                                   :limit="1"
                                   :on-remove="handleRemove"
                                   :on-success="handleRefSuccess"
                                   :before-upload="beforeRefUpload"
                                   accept=".pdf,.ppt,.pptx,.doc,.docx" >
                            <el-button type="primary">点击上传</el-button>
                            <template #tip>
                                <div class="el-upload__tip">
                                    只允许上传<span style="color: red">1</span>个.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                </div>
                            </template>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>

            <template #footer>
                <div class="disflex-row-center">
                    <el-button type="primary" @click="submitReflection">确定</el-button>
                    <el-button @click="isShowReflection=!isShowReflection">取消</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 反思详情 -->
        <el-dialog title="反思详情" v-model="isShowRefList" width="452px">
            <el-table show-overflow-tooltip height="calc(100vh - 300px)"
                      border
                      :data="refList"
                      highlight-current-row>
                <el-table-column type="index" align="center" label="序号" width="60" />
                <el-table-column width="100" align="center" label="教师姓名" prop="trueName">
                    <template #default="scope">
                        <div :title="scope.row.trueName" style="color: #409efe;">
                            {{ scope.row.trueName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="160" align="center" label="提交时间" prop="createTime">
                    <template #default="scope">
                        <div>
                            {{timestampToTime(scope.row.createTime)}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100" align="center" label="查看文件" >
                    <template #default="scope">
                        <el-image @click="handleFIleStatus(scope.row.file.status)" class="file-icon"
                                  :src="require('@/assets/file/file_view_color.png')"
                                  :preview-teleported="true"
                                  :preview-src-list="gainFileImgList(scope.row.file.imgUrl,scope.row.file.pages)">
                        </el-image>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <!-- 反思详情 -->
        <el-dialog title="教师名单详情" v-model="isShowDiscussList" width="292px">
            <el-table show-overflow-tooltip height="calc(100vh - 300px)"
                      border
                      :data="discussList"
                      highlight-current-row>
                <el-table-column type="index" align="center" label="序号" width="60" />
                <el-table-column width="100" align="center" label="教师姓名" prop="createUserName">
                    <template #default="scope">
                        <div :title="scope.row.createUserName" style="color: #409efe;">
                            {{ scope.row.createUserName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100" align="center" label="研讨数" prop="discussCount">
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import { timestampToTime } from "@/utils/date";
import {
    delLessonFile,
    lessonInfo,
    lessonMeeting,
    lessonStop,
    lessonEnd,
    lessonSubmit,
    lessonReflection,
    lessonUpdate,
    lessonRelease,
    lessonUploadReflection
} from "@/api/admin/lesson"
import {downloadFile} from "@/api/adminservice/public";
import {groupListAuthGroup, queryDict} from "@/api/admin/public";
import {serviceUrl, serviceWebUrl} from "@/utils/global"
import {classLibraryListAllBook, classLibraryListTree} from "@/api/admin/classLibrary";
import {userListOrgUsers} from "@/api/admin/system";
import choosePeople from "@/components/choosePeople.vue";
import html2canvas from "html2canvas";
import textMore from "@/components/common/textMore.vue";

export default {
    name: "teamLessonInfo",
    components: {choosePeople, vueQr, textMore},
    props: {
        lessonId: {
            type: String,
            default: null,
        },
        isTime: {
            type: Number,
            default: 1,
        },
    },
    watch: {
        lessonId(newValue, oldValue) {
            this.queryLessonInfo()
        },
    },
    data() {
        return {
            isLimitHeight: true,
            isOver: true,
            loading: false,
            isTimeShow: false,
            serviceUrl,
            token: this.$storage.get("token"),
            viewMode: 'view',
            editMode: 'edit',
            showMode: 'view',
            timestampToTime,
            lessonInfo: {
                coverUrl: 'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/msyk.png',
                groupId: '',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                lessonLevelKey: '',
                title: '',
                leadUser: '',
                teamUsers: '',
                teamuseList: [],
                guideUsers: '',
                guideUsersList: [],
                type: 0,
                lessonNature: '1'
            },
            // 表单校验
            isDirectory: false,
            isCourse: false,
            periodList: [],
            gradeList: [],
            subjectList: [],
            directoryList: [],
            tableData: [],
            lessonLevelList: [],
            //初案
            jaFiles: [],//教研
            xaFiles: [],//学案
            kjFiles: [],//课件
            xtFiles: [],//习题
            jAFileList: [],
            xAFileList: [],
            kJFileList: [],
            xTFileList: [],
            //修正案
            ytjaFiles: [],//教研
            ytxaFiles: [],//学案
            ytkjFiles: [],//课件
            ytxtFiles: [],//习题
            ytjAFileList: [],
            ytxAFileList: [],
            ytkJFileList: [],
            ytxTFileList: [],
            //共案
            gajaFiles: [],//教研
            gaxaFiles: [],//学案
            gakjFiles: [],//课件
            gaxtFiles: [],//习题
            gajAFileList: [],
            gaxAFileList: [],
            gakJFileList: [],
            gaxTFileList: [],
            //删除文件
            delFileList: [],

            rules: {
                lessonNature: [
                    {required: true, message: "请选择备课性质", trigger: "change"},
                ],
                groupId: [
                    {required: true, message: "请选择工作室/群组", trigger: "change"},
                ],
                periodKey: [
                    {required: true, message: "请选择学段", trigger: "change"},
                ],
                gradeKey: [
                    {required: true, message: "请选择年级", trigger: "change"},
                ],
                subjectKey: [
                    {required: true, message: "请选择学科", trigger: "change"},
                ],
                lessonLevelKey: [
                    {required: true, message: "请选择课题级别", trigger: "change"},
                ],
                title: [
                    {required: true, message: "请输入备课标题", trigger: "blur"},
                ],
                leadUser: [
                    {required: true, message: "请选择主备人", trigger: "change"},
                ],
                teamuseList: [
                    {required: true, validator: this.checkteamuseList},
                ],
                formTime: [
                    {required: true, validator: this.checkValidator}
                ],
            },
            qrCode: {
                shareUrl: '',
                shareZjUrl: '',
                size: 100,
                margin: 5,
                logoMargin: 5,
            },

            uploadCa: false,
            uploadXza: false,
            uploadGa: false,
            //会议
            meetingDisable: false,
            meetingFormRules: {
                meetingCode: [{required: true, message: "请输入腾讯会议号", trigger: "change"},],
                meetingTime: [{required: true, validator: this.checkMeetingTime}],
            },
            meetingForm: {
                lessonId: '',
                meetingCode: '',
                meetingTime: '',
            },
            //发布
            ckPeople: false,
            checkList: [],
            noShowIdList: [],
            // 编辑
            userList: [],
            groupList: [],
            natureList: [],
            // 教学反思
            isShowReflection: false,
            isShowRefList: false,
            isShowDiscussList: false,
            // 上传教学反思
            reflectionForm: {
                lessonId: '',
                fileUrl: '',
            },
            refFileList: [],
            refList: [],
            // 研讨统计
            discussList: [],
            oneDiscussList: [],
            twoDiscussList: [],
        };
    },
    created() {
        this.getQueryDict()
    },
    mounted() {
        // this.qrCode.shareUrl = serviceWebUrl+`/inviteMember?id=${ this.lessonId }&type=4`
        // this.qrCode.shareZjUrl = serviceWebUrl+`/inviteMember?id=${ this.lessonId }&type=5`
        this.qrCode.shareUrl = serviceWebUrl + `/invitePrepara?lessonId=${this.lessonId}&type=1`
        this.qrCode.shareZjUrl = serviceWebUrl + `/invitePrepara?lessonId=${this.lessonId}&type=2`
        this.queryLessonInfo()
    },
    computed: {},
    methods: {
        moreClick() {
            this.isLimitHeight = !this.isLimitHeight;
            this.moreText = this.isLimitHeight ? '...更多' : '收起';
        },
        editLesson() {
            this.showMode = this.editMode;
        },
        cancel() {
            this.showMode = this.viewMode;
        },
        queryLessonInfo() {
            this.delFileList.forEach(e => {
                delLessonFile({fileUrl: e});
            })
            queryDict({code: 'lession_xd_nj_xk'}).then(res => {
                this.periodList = res.data.data;
                lessonInfo({lessonId: this.lessonId}).then(res => {
                    if (res.data.code === 1) {
                        this.changeLessonNature(res.data.data.lessonNature)
                        this.lessonInfo = res.data.data;
                        this.$refs.leadUser.checkList = [{
                            userId: this.lessonInfo.leadUser,
                            trueName: this.lessonInfo.leadUserName
                        }];
                        this.$refs.teamuseList.checkList = this.lessonInfo.teamUserList;
                        this.$refs.guideUsersList.checkList = this.lessonInfo.guideUserList;
                        this.$refs.leadUser.disabledList = [...this.$refs.teamuseList.checkList, ...this.$refs.guideUsersList.checkList]
                        this.$refs.teamuseList.disabledList = [...this.$refs.leadUser.checkList, ...this.$refs.guideUsersList.checkList]
                        this.$refs.guideUsersList.disabledList = [...this.$refs.leadUser.checkList, ...this.$refs.teamuseList.checkList]
                        if (this.lessonInfo.lessonNature == 2 || this.lessonInfo.lessonNature == 3
                          || this.lessonInfo.lessonNature == 4) {
                            this.$refs.leadUser.getQunPeople(this.lessonInfo.groupId)
                            this.$refs.teamuseList.getQunPeople(this.lessonInfo.groupId)
                        }
                        //初案
                        this.jaFiles = []
                        this.xaFiles = []
                        this.kjFiles = []
                        this.xtFiles = []
                        this.jAFileList = []
                        this.xAFileList = []
                        this.kJFileList = []
                        this.xTFileList = []
                        this.jaFiles = this.lessonInfo.jaFiles;
                        this.xaFiles = this.lessonInfo.xaFiles;
                        this.kjFiles = this.lessonInfo.kjFiles;
                        this.xtFiles = this.lessonInfo.xtFiles;
                        this.lessonInfo.jaFiles.forEach(e => {
                            this.jAFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.lessonInfo.xaFiles.forEach(e => {
                            this.xAFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.lessonInfo.kjFiles.forEach(e => {
                            this.kJFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.lessonInfo.xtFiles.forEach(e => {
                            this.xTFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        //修正案
                        this.ytjaFiles = []
                        this.ytxaFiles = []
                        this.ytkjFiles = []
                        this.ytxtFiles = []
                        this.ytjAFileList = []
                        this.ytxAFileList = []
                        this.ytkJFileList = []
                        this.ytxTFileList = []
                        this.ytjaFiles = this.lessonInfo.ytjaFiles;
                        this.ytxaFiles = this.lessonInfo.ytxaFiles;
                        this.ytkjFiles = this.lessonInfo.ytkjFiles;
                        this.ytxtFiles = this.lessonInfo.ytxtFiles;
                        this.lessonInfo.ytjaFiles.forEach(e => {
                            this.ytjAFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.lessonInfo.ytxaFiles.forEach(e => {
                            this.ytxAFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.lessonInfo.ytkjFiles.forEach(e => {
                            this.ytkJFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.lessonInfo.ytxtFiles.forEach(e => {
                            this.ytxTFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        //共案
                        this.gajaFiles = []
                        this.gaxaFiles = []
                        this.gakjFiles = []
                        this.gaxtFiles = []
                        this.gajAFileList = []
                        this.gaxAFileList = []
                        this.gakJFileList = []
                        this.gaxTFileList = []
                        this.gajaFiles = this.lessonInfo.gajaFiles;
                        this.gaxaFiles = this.lessonInfo.gaxaFiles;
                        this.gakjFiles = this.lessonInfo.gakjFiles;
                        this.gaxtFiles = this.lessonInfo.gaxtFiles;
                        this.lessonInfo.gajaFiles.forEach(e => {
                            this.gajAFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.lessonInfo.gaxaFiles.forEach(e => {
                            this.gaxAFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.lessonInfo.gakjFiles.forEach(e => {
                            this.gakJFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.lessonInfo.gaxtFiles.forEach(e => {
                            this.gaxTFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        // 研讨
                        this.oneDiscussList = this.lessonInfo.oneDiscussList;
                        this.twoDiscussList = this.lessonInfo.twoDiscussList;
                        // 反思
                        this.refList = this.lessonInfo.refList;
                        if (this.lessonInfo.isRef === 1) {
                            const f = this.lessonInfo.reflection.file;
                            this.refFileList = [];
                            this.refFileList.push({
                                name: f.fileName,
                                fileId: f.fileId,
                                url: f.fileUrl,
                                response: {
                                    data: f.fileUrl
                                }
                            })
                        }
                        this.periodList.forEach(j => {
                            if (this.lessonInfo.periodKey === j.dictKey) {
                                this.gradeList = j.childrenList;
                            }
                        })
                        this.periodList.forEach(e => {
                            if (this.lessonInfo.periodKey === e.dictKey) {
                                e.childrenList.forEach(j => {
                                    if (this.lessonInfo.gradeKey === j.dictKey) {
                                        this.subjectList = j.childrenList;
                                    }
                                })
                            }
                        })
                        const textList = [];
                        res.data.data.teamUserList.forEach(j => {
                            textList.push(j.trueName)
                        })
                        res.data.data.teamUserNames = textList.join('、')
                        const guideList = [];
                        res.data.data.guideUserList.forEach(j => {
                            guideList.push(j.trueName)
                        })
                        res.data.data.guideNames = guideList.join('、')
                        this.showMode = this.viewMode;
                        this.isTimeShow = true;
                    }
                })
            })

        },
        viewFile(file) {
        },
        viewPPTFile(fileUrl) {
            const openUrl = 'https://ow365.cn/?i=36735&ssl=1&furl=' + fileUrl;
            window.open(openUrl, '_blank')
        },
        judgeIsPPT(fileType) {
            // if (!fileType){
            //     return false;
            // }
            // return fileType.toLowerCase().includes("ppt");
            return false;
        },
        downloadFile(item) {
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status) {
            if (status === 1) {

            } else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl, page,) {
            const list = [];
            for (let i = 1; i <= page; i++) {
                list.push(baseUrl + '/' + i + '.png');
            }
            return list;
        },
        getQueryDict() {
            queryDict({code: 'lession_xd_nj_xk'}).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({code: 'topic_level'}).then(res => {
                this.lessonLevelList = res.data.data;
            })
            queryDict({code: 'activity_nature'}).then(res => {
                this.natureList = res.data.data;
            })
        },
        changePeriod() {
            this.lessonInfo.gradeKey = '';
            this.lessonInfo.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.lessonInfo.periodKey == j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
        },
        changeGrade() {
            this.lessonInfo.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.lessonInfo.periodKey == e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.lessonInfo.gradeKey == j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
        },
        handleCoverSuccess(response, uploadFile) {
            if (uploadFile.response.code == 1) {
                this.lessonInfo.coverUrl = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeCoverUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        queryDirectory() {
            classLibraryListAllBook().then(res => {
                if (this.lessonInfo.periodKey !== '') {
                    res.data.data = res.data.data.filter(itemA => {
                        return itemA.periodKey == this.lessonInfo.periodKey
                    })
                }
                if (this.lessonInfo.gradeKey !== '') {
                    res.data.data = res.data.data.filter(itemA => {
                        return itemA.gradeKey == this.lessonInfo.gradeKey
                    })
                }
                if (this.lessonInfo.subjectKey !== '') {
                    res.data.data = res.data.data.filter(itemA => {
                        return itemA.subjectKey == this.lessonInfo.subjectKey
                    })
                }
                this.directoryList = JSON.parse(JSON.stringify(res.data.data));
                this.isDirectory = true;
            });
        },
        goCourse(item) {
            this.tableData = []
            classLibraryListTree().then(res => {
                res.data.data.forEach(e => {
                    if (item.classId == e.classId) {
                        if (e.childrenList) {
                            e.childrenList.forEach(j => {
                                if (j.childrenList) {
                                    j.childrenList.forEach((m, n) => {
                                        if (n == 0) {
                                            this.tableData.push({
                                                pid: j.classId,
                                                ptit: j.className,
                                                id: m.classId,
                                                title: m.className,
                                                col: j.childrenList.length,
                                                className: e.className
                                            })
                                        } else {
                                            this.tableData.push({
                                                pid: j.classId,
                                                ptit: j.className,
                                                id: m.classId,
                                                title: m.className,
                                                col: 0,
                                                className: e.className
                                            })
                                        }
                                    })
                                } else {
                                    this.tableData.push({
                                        pid: j.classId,
                                        ptit: j.className,
                                        id: '',
                                        title: '',
                                        col: 1,
                                        className: e.className
                                    })
                                }
                            })
                        }
                    }
                })
                this.isCourse = true
            })
        },
        changeTitle(row) {
            this.lessonInfo.title = row.className + '­—' + row.ptit + (row.title ? '­—' + row.title : '')
            this.isDirectory = false;
            this.isCourse = false;
        },
        objectSpanMethod(e) {
            // console.log(e);
            if (e.columnIndex === 0) {
                if (e.row.col != 0) {
                    return {
                        rowspan: e.row.col,
                        colspan: 1,
                    }
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    }
                }
            }
        },
        handleXTChange(file) {
        },
        handleJAChange(file) {
        },
        handleXAChange(file) {
        },
        handleKjChange(file) {
        },
        beforeJAUpload(rawFile) {
            if (!(rawFile.type == 'application/pdf' || rawFile.type == 'application/vnd.ms-powerpoint' || rawFile.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || rawFile.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || rawFile.type == 'application/msword')) {
                this.$message.error('文件必须是.pdf,.ppt,.pptx,.doc,.docx格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 200) {
                this.$message.error('文件大小不能超过200M')
                return false
            }
            return true
        },
        beforeRefUpload(rawFile) {
            if (!(rawFile.type == 'application/pdf' ||
              rawFile.type == 'application/vnd.ms-powerpoint' ||
              rawFile.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || rawFile.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || rawFile.type == 'application/msword')) {
                this.$message.error('文件必须是.pdf,.ppt,.pptx,.doc,.docx格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 200) {
                this.$message.error('文件大小不能超过200M')
                return false
            }

            return true
        },
        handleRemove(file, uploadFiles) {
            if (file.response.data) {
                this.delFileList.push(file.response.data)
            }
        },
        submitForm() {
            this.lessonInfo.beginTime = this.setHms(this.lessonInfo.beginTime);
            this.lessonInfo.endTime = this.setHms(this.lessonInfo.endTime);
            this.lessonInfo.teamuseList = [];
            this.lessonInfo.guideUsersList = [];
            this.$refs.teamuseList.checkList.forEach(e => {
                this.lessonInfo.teamuseList.push(e.userId)
            })
            this.$refs.guideUsersList.checkList.forEach(e => {
                this.lessonInfo.guideUsersList.push(e.userId)
            })
            if (this.$refs.leadUser.checkList.length !== 0) {
                this.lessonInfo.leadUser = this.$refs.leadUser.checkList[0].userId;
            } else {
                this.lessonInfo.leadUser = '';
            }
            this.lessonInfo.teamUsers = this.lessonInfo.teamuseList.toString()
            this.lessonInfo.guideUsers = this.lessonInfo.guideUsersList.toString()
            this.$refs["form"].validate(valid => {
                if (valid) {
                    var obj = JSON.parse(JSON.stringify(this.lessonInfo));
                    obj.type = 0
                    delete obj.teamuseList
                    delete obj.guideUsersList
                    lessonUpdate(obj).then(res => {
                        if (res.data.code === 1) {
                            this.queryLessonInfo()
                            this.$message.success("操作成功");
                        }
                    })
                }
            });
        },
        handleUploadCaFile() {
            this.uploadCa = true;
        },
        handleUploadXzaFile() {
            this.uploadXza = true;
        },
        handleUploadGaFile() {
            this.uploadGa = true;
        },
        handleGAJaChange(e, type) {
            if (e.response) {
                if (e.response.code == 1) {
                    let arr = []
                    this.lessonInfo.gajaFiles.forEach(j => {
                        var fileUrl = ''
                        if (j.url) {
                            fileUrl = j.url
                        } else {
                            fileUrl = j.response.data
                        }
                        if (fileUrl != e.response.data) {
                            arr.push(new Promise(function (resolve, reject) {
                                delLessonFile({fileUrl: fileUrl}).then(res => {
                                    resolve(res.data.code)
                                })
                            }))
                        }
                    })
                    Promise.all(arr).then((result) => {
                        this.queryLessonInfo()
                    })

                } else {

                }
            }
        },
        handleAvatarSuccess(response, uploadFile) {
            if (uploadFile.response.code == 1) {
                this.lessonInfo.coverUrl = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }

        },
        handleRefSuccess(response, uploadFile) {
            if (uploadFile.response.code === 1) {
                this.reflectionForm.fileUrl = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }

        },
        beforeAvatarUpload(rawFile) {
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        //开始协同备课
        handleSubmit() {
            if (this.lessonInfo.status === 1) {
                if (this.lessonInfo.jaFiles.length === 0 &&
                  this.lessonInfo.xaFiles.length === 0 &&
                  this.lessonInfo.kjFiles.length === 0 &&
                  this.lessonInfo.xtFiles.length === 0) {
                    this.$message.error("请先上传初案");
                    return
                }
            }
            if (this.lessonInfo.status === 3) {
                if (this.lessonInfo.ytjaFiles.length === 0 &&
                  this.lessonInfo.ytxaFiles.length === 0 &&
                  this.lessonInfo.ytkjFiles.length === 0 &&
                  this.lessonInfo.ytxtFiles.length === 0) {
                    this.$message.error("请先上传修正案");
                    return
                }
            }
            lessonSubmit({lessonId: this.lessonId}).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.queryLessonInfo()
                } else {
                    this.$message.error("请求失败");
                }
            })
        },
        beginSecondDiscuss() {
            this.handleSubmit();
        },
        // 教学反思
        handleReflection() {
            if (this.lessonInfo.gajaFiles.length === 0 &&
              this.lessonInfo.gaxaFiles.length === 0 &&
              this.lessonInfo.gakjFiles.length === 0 &&
              this.lessonInfo.gaxtFiles.length === 0) {
                this.$message.error("请先上传共案");
                return
            }
            lessonReflection({lessonId: this.lessonId}).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.queryLessonInfo()
                } else {
                    this.$message.error("请求失败");
                }
            })
        },
        handleUploadReflection() {
            this.isShowReflection = true;
            this.reflectionForm.lessonId = this.lessonInfo.lessonId;
        },
        submitReflection() {
            if (!this.reflectionForm.fileUrl) {
                this.$message.error("请上传教学反思文件");
                return;
            }
            lessonUploadReflection(this.reflectionForm).then(res => {
                if (res.data.code === 1) {
                    this.queryLessonInfo();
                    this.isShowReflection = false;
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        // 协同研讨
        handleDiscuss() {
            let routeUrl = this.$router.resolve({
                path: '/lessonDiscuss',
                query: {lessonId: this.lessonId}
            })
            window.open(routeUrl.href, '_blank')
        },
        handleDiscussMode(mode) {
            let routeUrl = this.$router.resolve({
                path: '/viewLessonDiscuss',
                query: {lessonId: this.lessonId, mode: mode, isDis: '0'}
            })
            window.open(routeUrl.href, '_blank')
        },
        // 发起会议
        handleMeeting() {

            this.meetingDisable = true;
            this.meetingForm.lessonId = this.lessonId;
        },
        checkMeetingTime(rule, value, callback) {
            if (this.meetingForm.meetingTime === '' || !this.meetingForm.meetingTime) {
                callback(new Error('请选择腾讯会议开始时间'))
            } else {

            }
        },
        subMeeting() {
            if (this.meetingForm.meetingTime === '') {
                this.$message.info("会议时间不能为空")
                return
            }
            if (this.meetingForm.meetingCode === '') {
                this.$message.info("会议号不能为空")
                return
            }
            this.meetingForm.meetingTime = this.setHms(this.meetingForm.meetingTime);
            lessonMeeting(this.meetingForm).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("发起成功");
                    this.meetingDisable = false;
                } else {
                    this.$message.error("操作失败")
                }
            })

        },
        cancelMeeting() {
            this.meetingDisable = false;
        },
        // 停止协同
        handleStop() {
            lessonStop({lessonId: this.lessonId}).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.queryLessonInfo()
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        //结束备课
        handleEndLesson() {
            if (this.lessonInfo.gajaFiles.length === 0 &&
              this.lessonInfo.gaxaFiles.length === 0 &&
              this.lessonInfo.gakjFiles.length === 0 &&
              this.lessonInfo.gaxtFiles.length === 0) {
                this.$message.error("请先上传修正案");
                return
            }
            lessonEnd({lessonId: this.lessonId}).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.queryLessonInfo()
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        //发布备课
        handleRelease() {
            this.noShowIdList = []
            this.lessonInfo.guideUserList.forEach(e => {
                this.noShowIdList.push(e.userId)
            })
            this.lessonInfo.teamUserList.forEach(e => {
                this.noShowIdList.push(e.userId)
            })
            this.noShowIdList.push(this.lessonInfo.leadUser)
            this.checkList = [];
            userListOrgUsers().then(res => {
                res.data.data.orgList.forEach(e => {
                    e.title = e.orgName;
                    if (e.groupList) {
                        e.groupList.forEach(j => {
                            j.title = j.groupName
                        })
                    }
                })
                this.orgList = res.data.data.orgList;
                this.ckPeople = true;
            })
        },
        submitCkPeopleForm() {
            var checkList = []
            this.$refs.ckPeople.checkList.forEach(e => {
                checkList.push(e.userId)
            })
            lessonRelease({lessonId: this.lessonId, viewUsers: checkList.toString()}).then(res => {
                if (res.data.code === 1) {
                    this.ckPeople = false;
                    this.ckPeopleList = [];
                    this.$message.success("已发布，请等待审核");
                    this.queryLessonInfo()
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        closeCkPeople() {
            this.ckPeople = false;
        },
        changeLessonNature(e) {
            console.log(e);
            this.groupList = [];
            this.lessonInfo.groupId = '';
            if (e == 1) {
                this.sxKj()
                this.$refs.leadUser.getUserList()
                this.$refs.teamuseList.getUserList()
                this.$refs.guideUsersList.getUserList()
            } else if (e == 2) {
                groupListAuthGroup({groupNature: 2}).then(res => {
                    this.groupList = res.data.data;
                })
                this.sxKj()
                this.$refs.leadUser.getUserList()
                this.$refs.teamuseList.getUserList()
                this.$refs.guideUsersList.getUserList()
            } else if (e == 3) {
                groupListAuthGroup({groupNature: 3}).then(res => {
                    this.groupList = res.data.data;
                })
                this.sxKj()
                this.$refs.leadUser.getUserList()
                this.$refs.teamuseList.getUserList()
                this.$refs.guideUsersList.getUserList()
            } else if (e == 4) {
                this.sxKj()
                groupListAuthGroup({groupNature: 1}).then(res => {
                    this.groupList = res.data.data;
                })
            }
        },
        sxKj() {
            this.$refs.leadUser.checkList = []
            this.$refs.leadUser.disabledList = []
            this.$refs.teamuseList.checkList = []
            this.$refs.guideUsersList.checkList = []
            this.$refs.teamuseList.disabledList = []
            this.$refs.guideUsersList.disabledList = []
        },
        gxDisable() {
            this.$refs.leadUser.disabledList = [...this.$refs.teamuseList.checkList, ...this.$refs.guideUsersList.checkList]
            this.$refs.teamuseList.disabledList = [...this.$refs.leadUser.checkList, ...this.$refs.guideUsersList.checkList]
            this.$refs.guideUsersList.disabledList = [...this.$refs.leadUser.checkList, ...this.$refs.teamuseList.checkList]
        },
        changeQun() {
            this.sxKj()
            this.$refs.leadUser.getQunPeople(this.lessonInfo.groupId)
            this.$refs.teamuseList.getQunPeople(this.lessonInfo.groupId)
        },
        checkteamuseList(rule, value, callback) {
            if (this.$refs.teamuseList.checkList.length === 0) {
                callback(new Error('请选择协备人员'))
            } else {
                callback()
            }
        },
        handleXbDownload() {
            html2canvas(this.$refs.xbcode.$el, {
                backgroundColor: "#ffffff",
                useCORS: true,
                allowTaint: true,
                scale: 2,
                dpi: 300
            }).then(async canvas => {
                // 生成图片地址
                const imgUrl = canvas.toDataURL('image/png');
                const eleLink = document.createElement('a');
                eleLink.href = imgUrl;
                eleLink.download = this.lessonInfo.title + '-协备邀请码.png';
                // // 下载
                eleLink.click();
            })
        },
        handleZjDownload() {
            html2canvas(this.$refs.zjcode.$el, {
                backgroundColor: "#ffffff",
                useCORS: true,
                allowTaint: true,
                scale: 2,
                dpi: 300
            }).then(async canvas => {
                // 生成图片地址
                const imgUrl = canvas.toDataURL('image/png');
                const eleLink = document.createElement('a');
                eleLink.href = imgUrl;
                eleLink.download = this.lessonInfo.title + '-专家邀请码.png';
                // // 下载
                eleLink.click();
            })
        },
        //1-未开始 2-进行中 3-已完成
        judgeLessonStatus(num, status) {
            if (num > status) {
                return 1;
            }
            if (num === status) {
                return 2;
            }
            return 3;
        },
        viewRefDetail() {
            this.isShowRefList = true;
        },

        viewDiscussDetail(num) {
            this.discussList = [];
            if (num === 1) {
                this.discussList = this.oneDiscussList;
            }
            if (num === 2) {
                this.discussList = this.twoDiscussList;
            }
            this.isShowDiscussList = true;
        }

    }
};
</script>
<style scoped>
.course-container {
    width: 100%;
    height: auto;
    background-color: #fff;
    padding-left: 15px;
    box-sizing: border-box;
    padding-bottom: 10px;
    padding-right: 10px;
}

.lesson-container {
    width: 100%;
    height: auto;
    padding-bottom: 10px;
}

.top-title {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
    color: #3b62f8;
    font-weight: bold;
}

.info-column-container {
    display: flex;
    width: 100%;
    height: 25px;
}

.info-column-container-top {
    display: flex;
    width: 100%;
    height: 25px;
    border-bottom: 2px solid #3b62f8;
}

.file-classify-container {
    width: 100%;
    height: 46px;
    border-bottom: 2px solid #3b62f8;
    padding-top: 10px;
    box-sizing: border-box;
}

.top-file-classify {
    width: 60px;
    height: 24px;
    line-height: 24px;
    background-color: #3b62f8;
    color: #fff;
    text-align: center;
    font-size: 14px;
    border-radius: 12px;
}

.flex-item:last-child {
    margin-left: auto;
}

.column-title {
    height: 20px;
    line-height: 20px;
    color: #ffbf6b;
    font-weight: bold;
    border-left: 4px solid #3b62f8;
    font-size: 16px;
    text-indent: 5px;
    width: 100px;
}

.column-status {
    width: auto;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    padding: 0 6px 0 6px;
    background-color: #a2ef4d;
    font-size: 12px;
    text-align: center;
    color: #e87b17;
}

.column-status-fb {
    width: auto;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    padding: 0 6px 0 6px;
    background-color: #e87b17;
    font-size: 12px;
    text-align: center;
    color: #a2ef4d;
}

.column-btn {
    padding-right: 10px;
    display: flex;
}

.btn {
    width: auto;
    height: 20px;
    border: 1px solid #3b62f8;
    color: #3b62f8;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    border-radius: 4px;
    cursor: pointer;
    margin-right: 10px;
    padding-left: 5px;
    padding-right: 5px;
}

.base-info-container {
    display: flex;
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    padding-top: 10px;
}

.base-info-content {
    width: calc(100% - 260px);
    padding-right: 20px;
    box-sizing: border-box;
}

.base-info-cover {
    //width: 320px;
    //height: 232px;
    width: 260px;
    height: 188px;
    padding-right: 10px;
    box-sizing: border-box;
}

.info-lesson-title {
    width: 100%;
    height: auto;
    font-size: 16px;
    color: #333;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    padding-right: 100px;
    box-sizing: border-box;

}

.info-item-column {
    display: flex;
    width: 100%;
    height: 24px;
    font-size: 14px;
    line-height: 24px;

    div {
        width: 33.3%;
        font-size: 14px;
        line-height: 24px;
    }
}

.info-label {
    width: 70px;
}

.info-item-level {
    //padding-left: 50px;
}

.code-title {
    width: 100px;
    height: 20px;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
}

.lesson-team-code-container {
    width: 100%;
    height: auto;
    display: flex;
}

.lesson-team-item {
    width: 60%;
    height: auto;
    padding-right: 20px;
    box-sizing: border-box;
}

.lesson-user {
    display: flex;
    width: 100%;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
}

.lesson-lead {
    width: 60%;
}

.lesson-guide {
    width: 40%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.lesson-team {
    display: flex;
    width: 100%;
    height: auto;
    line-height: 24px;
    font-size: 14px;
    //display: -webkit-box;
    //-webkit-line-clamp: 4;
    //-webkit-box-orient: vertical;
    //overflow: hidden;
}

.lesson-code-item {
    width: 40%;
    height: 120px;
    font-size: 14px;
    display: flex;
}

.code-container {
    width: 50%;
}

.file-info-container {
    width: 100%;
    height: auto;
}

.file-container {
    display: flex;
    width: 100%;
    height: auto;
    padding-top: 10px;
    border-bottom: 2px solid #a7a7a7;
}

.file-type {
    width: 60px;
    font-size: 15px;
}

.file-classify {
    width: 56px;
    height: 24px;
    line-height: 24px;
    background-color: #93d2f3;
    color: #3f3f3f;
    margin: auto;
    text-align: center;
    font-size: 14px;
    border-radius: 10px;
}

.file-list {
    width: calc(100% - 60px);
    height: auto;
}

.file-item {
    display: flex;
    height: 30px;
    width: 100%;
    padding-left: 10px;
    padding-right: 20px;
    box-sizing: border-box;
}

.file-item:hover {
    color: #3b62f8 !important;
    font-weight: bold;
}

.file-title {
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
    cursor: pointer;
}

.file-view {
    width: 30px;
    height: 100%;
}

.file-download {
    width: 30px;
    height: 100%;
}

.file-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

/*编辑*/
.avatar-uploader .avatar {
    width: 240px;
    height: 152px;
    display: block;
    object-fit: cover;
}

.avatar-uploader /deep/ .el-upload {
    width: 240px;
    height: 152px;
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}

.el-icon .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 240px;
    height: 152px;
    text-align: center;
}

/*时间安排*/
.lesson-time-container {
    width: 100%;
    height: auto;
    padding: 0 10px 10px 0;
    box-sizing: border-box;
}

.topic-time-top {
    width: 100%;
    height: 26px;
    display: flex;
}

.topic-time-top1 {
    width: 24px;
    height: 26px;
    padding-top: 2px;
    box-sizing: border-box;
}

.topic-time-top2 {
    width: calc(100% - 24px);
    height: 26px;
    font-size: 15px;
    font-weight: bold;
    color: #333333;
}

.lesson-time-item-container {
    width: 100%;
    height: 44px;
    padding-left: 4px;
    box-sizing: border-box;
}

.lesson-time-item-container-finish {
    width: 100%;
    height: 24px;
    padding-left: 4px;
    box-sizing: border-box;
}

.lesson-time-info-container {
    width: 100%;
    height: 24px;
    display: flex;
}

.lesson-time-yd {
    width: 10px;
    height: 10px;
    border-radius: 10px;
    margin-top: 7px;
}

.lesson-time-info {
    width: calc(100% - 220px);
    height: 24px;
    display: flex;
}

.lesson-status-title {
    width: 100px;
    padding: 0 0 0 20px;
    height: 24px;
    font-weight: bold;
    font-size: 14px;
    line-height: 24px;
    box-sizing: border-box;
}

.lesson-status-time {
    width: 200px;
    height: 24px;
    font-weight: bold;
    font-size: 13px;
    line-height: 24px;
}

.lesson-status-join-tea {
    width: auto;
    height: 24px;
    padding: 0 5px 0 10px;
    font-weight: bold;
    font-size: 13px;
    line-height: 24px;
}

.lesson-status-join-tea-active {
    width: auto;
    height: 24px;
    padding: 0 5px 0 10px;
    font-weight: bold;
    font-size: 13px;
    line-height: 24px;
    color: #3b62f8 !important;
}

.lesson-status-join-info {
    width: auto;
    height: 24px;
    font-weight: bold;
    padding: 0 5px 0 10px;
    font-size: 13px;
    line-height: 24px;
}

.lesson-status-join-info-active {
    width: auto;
    height: 24px;
    font-weight: bold;
    padding: 0 5px 0 10px;
    font-size: 13px;
    line-height: 24px;
    color: #68bbc4 !important;
}

.lesson-time-operation {
    width: 200px;
    height: 24px;
    display: flex;
}

.operation-btn {
    width: auto;
    height: 20px;
    display: flex;
    margin-left: 10px;
    margin-top: 2px;
    line-height: 20px;
    font-size: 12px;
    border-radius: 4px;
    text-align: center;
    padding: 0 5px 0 5px;
    cursor: pointer;
}

.lesson-time-line-container {
    width: 90%;
    height: 20px;

    margin-left: 3.5px;
}

/*未开始*/
.status-wks {
    color: #767676 !important;
}

.bg-wks {
    background-color: #767676 !important;
}

.border-wks1 {
    border: 1px solid #767676;
    color: #767676 !important;
}

.border-wks2 {
    border-left: 2px solid #767676;
}

/*进行中*/
.status-jxz {
    color: #ee6819 !important;
}

.bg-jxz {
    background-color: #ee6819 !important;
}

.border-jxz1 {
    border: 1px solid #ee6819;
    color: #ee6819 !important;
}

.border-jxz2 {
    border-left: 2px solid #ee6819;
}

/*已完成*/
.status-ywc {
    color: #3b62f8 !important;
}

.bg-ywc {
    background-color: #3b62f8 !important;
}

.border-ywc1 {
    border: 1px solid #3b62f8;
    color: #3b62f8 !important;
}

.border-ywc2 {
    border-left: 2px solid #3b62f8;
}
</style>

